import { HistoricalObsProvider } from '../providers/historicalObsProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_HISTORICAL_OBS_BY_PROVIDER = new AsyncAction('GET_HISTORICAL_OBS_BY_PROVIDER');

export function getHistoricalObsByProvider(...params) {

    let paramsObject = {
        startdatetimeutc: undefined,
        enddatetimeutc: undefined,
        stationId: undefined,
        providerId: undefined,
        units: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        lengthUnit: undefined,
        tempUnit: undefined,
        pressureUnit: undefined,
        speedUnit: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_HISTORICAL_OBS_BY_PROVIDER.base,
        payload: getHistoricalObs(paramsObject)
    };
}

export async function getHistoricalObs({ startdatetimeutc, enddatetimeutc, stationId, providerId, units, baseUrl, authId, secret, stdParameters, verbose, refresh, lengthUnit, tempUnit, pressureUnit, speedUnit }) {
    const op = new HistoricalObsProvider(baseUrl, authId, secret);
    return await op.getHistoricalObs(startdatetimeutc, enddatetimeutc, stationId, providerId, units, stdParameters, verbose, refresh, lengthUnit, tempUnit, pressureUnit, speedUnit);
}
